import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import { Observable, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AuthState } from '@app/modules/auth/store/auth.state';
import { UserState } from '@app/modules/user/store/user.state';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.sass'],
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  private _subscription = new Subscription();
  @Select(AuthState.loading) public authLoading$: Observable<boolean>;
  @Select(UserState.loading) public userLoading$: Observable<boolean>;

  /**
   * @param store
   */
  constructor(
    private readonly store: Store,
  ) {}

  public ngOnInit(): void {
    this.isAuthorized();
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  private isAuthorized(): void {
    this._subscription.add(
      this.store
        .select((state) => state.auth.isAuthorized)
        // `filter + take(1)`: redirect once, never repeatedly. A live
        // subscription here re-dispatched the navigation on every state
        // change, and the route guard bounced it straight back — the two
        // together could ping-pong until the page locked up.
        .pipe(
          filter((isAuth: boolean) => isAuth),
          take(1),
        )
        .subscribe(() => this.store.dispatch(new Navigate([this.landingRouteForRole()])))
    );
  }

  /**
   * Where a person lands after signing in.
   *
   * Everyone lands on /office; patients are then forwarded to /office/portal
   * by the dashboard route. The post-login freeze once blamed on the portal
   * page was actually the router preloading every lazy module at once after
   * auth (see CorePreloadingStrategy) — the portal itself is fine.
   */
  private landingRouteForRole(): string {
    return '/office';
  }
}
